import { ReactElement } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { IconBuilding } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';
import useAuth from 'hooks/useAuth';

interface RequireHotelProps {
  children: ReactElement;
}

export default function RequireHotel({ children }: RequireHotelProps) {
  const { selectedHotelId, allowedHotels } = useAuth();

  if (allowedHotels.length === 0) {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid size={12}>
          <MainCard>
            <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <IconBuilding size={24} stroke={1.5} />
              <FormattedMessage id="requireHotel.none.title" defaultMessage="Nincs elérhető hotel" />
            </Typography>
            <Typography color="text.secondary">
              <FormattedMessage id="dashboard.noHotelTitle" defaultMessage="Nincs megjeleníthető hotel a jogosultságaid alapján." />
            </Typography>
          </MainCard>
        </Grid>
      </Grid>
    );
  }

  if (!selectedHotelId) {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid size={12}>
          <MainCard>
            <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <IconBuilding size={24} stroke={1.5} />
              <FormattedMessage id="requireHotel.pick.title" defaultMessage="Válassz hotelt" />
            </Typography>
            <Typography color="text.secondary">
              <FormattedMessage id="dashboard.noHotelHint" defaultMessage="Válassz hotelt a fejlécben a folytatáshoz." />
            </Typography>
          </MainCard>
        </Grid>
      </Grid>
    );
  }

  return children;
}
